import React, {
  ReactNode,
} from 'react';
import clsx from 'clsx';
import BaseDialog from 'pages/Dashboard/components/Dialog';
import {
  walkthroughContent,
} from 'views/EMR/components/PCC/Walkthrough/content';
import WalkthroughIcon from 'views/EMR/components/PCC/Walkthrough/icons';
import 'views/EMR/components/PCC/Walkthrough/styles.css';

type Props = {
  open: boolean;
  onClose: () => void;
  disableClose?: boolean;
  children: ReactNode;
  showStandaloneClose?: boolean;
  className?: string;
};

export default function DialogShell({
  open,
  onClose,
  disableClose = false,
  children,
  showStandaloneClose = false,
  className,
}: Props) {
  return (
    <BaseDialog
      open={open}
      onClose={onClose}
      hideCloseBtn
      showActions={false}
      disableBackdropClick
      disableEscapeKeyDown={disableClose}
      maxWidth={false}
      fullWidth
      ariaLabel={walkthroughContent.shared.dialogAriaLabel}
      className={className}
      classes={{
        root: 'pcc-walkthrough-root pcc-walkthrough-content !w-full !h-screen flex flex-col !p-0 !space-y-0 !text-[15px]',
        dialog: 'pcc-walkthrough-dialog hidden-backdrop populate-iframe-modal !m-0',
        bodyRoot: 'pcc-walkthrough-paper !w-screen !m-0 !max-w-[calc(100%-12px)]',
        container: '!justify-start',
      }}
    >
      <div className="pcc-walkthrough-shell relative flex h-full min-h-0 flex-col overflow-hidden bg-[#F4F5F5]">
        {showStandaloneClose ? (
          <div className="absolute right-3 top-3 z-10 sm:right-5 sm:top-5">
            <button
              type="button"
              aria-label={walkthroughContent.shared.closeAriaLabel}
              disabled={disableClose}
              onClick={onClose}
              className={clsx(
                'flex h-11 w-11 items-center justify-center rounded-full',
                'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-500',
                disableClose
                  ? 'cursor-not-allowed opacity-50'
                  : 'hover:bg-white/70',
              )}
            >
              <WalkthroughIcon
                iconKey="close"
                className="!h-5 !w-5 !text-[#475569]"
              />
            </button>
          </div>
        ) : null}
        {children}
      </div>
    </BaseDialog>
  );
}
